module.exports = __webpack_public_path__ + "media/images/emblems/Riddes_wappen-c0d3bb36bf4bffefe7ca23197cefb361.png";